<app-window-title [title]="'Have you finished?'" [closable]=true></app-window-title>
<p>
  <span> The session time is about to expire: {{ timer }}</span>
</p>

<button (click)="continue()" mat-flat-button color="warn">CONTINUE</button>&nbsp;
<button (click)="finished()" mat-flat-button color="warn">
  I HAVE FINISHED
</button>
